<template lang="pug">
img.cc-icon(
  :src="src"
  :width="size"
)
</template>

<script>
import amex from 'payment-icons/min/flat/amex.svg';
import discover from 'payment-icons/min/flat/discover.svg';
import generic from 'payment-icons/min/flat/default.svg';
import mastercard from 'payment-icons/min/flat/mastercard.svg';
import visa from 'payment-icons/min/flat/visa.svg';

export default {
  name: 'cc-icon',
  computed: {
    src() {
      switch (this.brand.toLowerCase()) {
        case 'american express':
          return amex;
        case 'discover':
          return discover;
        case 'generic':
          return generic;
        case 'mastercard':
          return mastercard;
        case 'visa':
          return visa;
        default:
      }
      return generic;
    },
  },
  props: {
    brand: {
      type: String,
      default: 'generic',
    },
    size: {
      type: Number,
      default: 36,
    },
  },
};
</script>

<style lang="scss">
</style>
